import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';

// Slider au début de la page d'accueil
const sliderContainer = document.querySelector('.slider');
if (sliderContainer) {
    const sliderSwiper = new Swiper(sliderContainer, {
        modules: [Autoplay, Pagination],
        autoHeight: true,
        loop: true,
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: {
            delay: 7000,
        },
        speed: 700,
        effect: 'slide',
        on: {
            init() {
                equalizeSlideHeights();
            },
            resize() {
                equalizeSlideHeights();
            },
        },
    });

    function equalizeSlideHeights() {
        const slides = sliderContainer.querySelectorAll('.swiper-slide');

        let textSlides = [];
        slides.forEach(slide => {
            const textPart = slide.querySelector('.bg-color-orange-cut');
            if (textPart) {
                textSlides.push(textPart);
            }
        });

        textSlides.forEach(textSlide => textSlide.style.height = '');

        let textSlideMaxHeight = 0;
        textSlides.forEach(textSlide => {
            const h = textSlide.offsetHeight;
            if (h > textSlideMaxHeight) {
                textSlideMaxHeight = h;
            }
        });

        textSlides.forEach(textSlide => {
            textSlide.style.height = `${textSlideMaxHeight}px`;
        });
    }
}

// Sélection de produits par catégorie dans la page d'accueil
const selectionContainer = document.querySelector('.selection');
if (selectionContainer) {
    const selectionSwiper = new Swiper(selectionContainer, {
        autoHeight: true,
        grabCursor: true,
        breakpoints: {
            1164: {
                slidesPerView: 4,
            },
            984: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        }
    });

    const linkCuisine = document.getElementById('link-cuisine');
    const linkMedical = document.getElementById('link-medical');
    
    if (linkCuisine && linkMedical) {
        function linkCuisineClickActions() {
            linkCuisine.classList.add('text-dark', 'text-decoration-underline');
            linkCuisine.classList.remove('text-light');
            linkMedical.classList.add('text-light')
            linkMedical.classList.remove('text-dark', 'text-decoration-underline');
    
        }

        function linkMedicalClickActions() {
            linkMedical.classList.add('text-dark', 'text-decoration-underline');
            linkMedical.classList.remove('text-light');
            linkCuisine.classList.add('text-light')
            linkCuisine.classList.remove('text-dark', 'text-decoration-underline');
        }

        linkCuisine.addEventListener('click', () => {
            linkCuisineClickActions();
            selectionSwiper.slideTo(0, 600);
        });
        
        linkMedical.addEventListener('click', () => {
            linkMedicalClickActions();
            selectionSwiper.slideTo(4, 600);
        });

        selectionSwiper.on('slideChange', () => {
            if (selectionSwiper.activeIndex >= 4) {
                linkMedicalClickActions();
            }
            else{
                linkCuisineClickActions();
            }
        });
    }
}

function initGenericSwiper(swiperContainerClass) {
    const container = document.querySelector(swiperContainerClass);

    if (container) {
        const swiper = new Swiper(container, {
            autoHeight: true,
            grabCursor: true,
            modules: [Pagination],
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                1164: {
                    slidesPerView: 4,
                },
                984: {
                    slidesPerView: 3,
                },
                576: {
                    slidesPerView: 2,
                },
                0: {
                    slidesPerView: 1,
                },
            }
        });

        const paginationEl = container.querySelector('.swiper-pagination');
        const slidesCount = container.querySelectorAll('.swiper-slide').length;

        function updatePaginationVisibility() {
            const width = window.innerWidth;
            const slidesPerView = (width >= 1164) ? 4 : (width >= 984) ? 3 : (width >= 576) ? 2 : 1;

            if (slidesCount <= slidesPerView) {
                paginationEl.style.display = 'none';
            }
            else {
                paginationEl.style.display = '';
            }
        }

        updatePaginationVisibility();
        window.addEventListener('resize', updatePaginationVisibility);
    }
}

initGenericSwiper('.promotions');
initGenericSwiper('.similaires');